/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerToJSON,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner';

/**
 * 
 * @export
 * @interface CreateScreenerLeadTag201Response
 */
export interface CreateScreenerLeadTag201Response {
    /**
     * 
     * @type {FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner}
     * @memberof CreateScreenerLeadTag201Response
     */
    data?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner;
}

/**
 * Check if a given object implements the CreateScreenerLeadTag201Response interface.
 */
export function instanceOfCreateScreenerLeadTag201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateScreenerLeadTag201ResponseFromJSON(json: any): CreateScreenerLeadTag201Response {
    return CreateScreenerLeadTag201ResponseFromJSONTyped(json, false);
}

export function CreateScreenerLeadTag201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateScreenerLeadTag201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerFromJSON(json['data']),
    };
}

export function CreateScreenerLeadTag201ResponseToJSON(value?: CreateScreenerLeadTag201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerToJSON(value.data),
    };
}

